module.exports = __webpack_public_path__ + "static/media/motherboard_3x3_top_solid.b3572887.svg";